<template>
    <div class="content">
        <div class="tabBtn">
            <div class="tabBtnLi" @click="send">
                <div class="tabBtnLiImg">
                    <img src="../assets/images/fs.png" alt="" />
                </div>
                <div class="tabBtnName">发送</div>
            </div>
        </div>
        <div v-if="isMobile" class="mobile-file-list">
            <div
                v-for="(item, index) in dataList"
                :key="index"
                class="file-card"
            >
                <div class="card-header">
                    <el-checkbox
                        v-model="item.checked"
                        @change="handleCheckChange(item)"
                    ></el-checkbox>
                    <div class="file-icon" @click="rowClicks(item.filePath)">
                        <i :class="getFileIcon(item.fileType)"></i>
                    </div>
                    <div class="file-info" @click="rowClicks(item.filePath)">
                        <div class="file-name">
                            {{ item.fileName }}
                        </div>
                        <div class="file-meta">
                            <span>{{ item.fileSize }}</span>
                            <span>{{ item.createTime }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-table
            class="tabaleBox"
            ref="multipleTable"
            :data="dataList"
            tooltip-effect="dark"
            style="width: 100%"
            height="100%"
            @row-click="rowClick"
            @selection-change="handleSelectionChange"
            v-else
        >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="文件名">
                <template slot-scope="scope">
                    {{ scope.row.fileName }}
                </template>
            </el-table-column>
            <el-table-column prop="fileSize" label="文件大小">
            </el-table-column>
            <el-table-column prop="fileType" label="类型" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                prop="createTime"
                label="时间"
                show-overflow-tooltip
            >
            </el-table-column>
        </el-table>
        <el-dialog title="等待中" :visible.sync="dialogTableVisible">
            <div class="erwmBox">
                <div class="erwmNum">{{ dataMsg.shareCode }}</div>
                <div class="erwmImg">
                    <canvas ref="qrCanvas" style="background: #f5f5f5"></canvas>
                    <!-- <img src="../assets/images/logo.png" alt="" /> -->
                </div>
                <div class="erwmTip">请在另一个设备中输入6位数密钥</div>
                <div class="erwmTime" @click="dialogTime = true">
                    <div class="erwmTimeName">有效期</div>
                    <div class="erwmTimeKey">
                        {{ dataMsg.validityData
                        }}<i class="el-icon-arrow-right"></i>
                    </div>
                </div>
                <div class="erwmBtn">分享链接</div>
            </div>
        </el-dialog>
        <el-dialog
            title="有效期设置"
            :visible.sync="dialogTime"
            custom-class="timeCss"
        >
            <div class="validityBox">
                <div class="validity">
                    <div class="validityTit"><span>*</span>有效期</div>
                    <div class="validityDay">
                        <div
                            class="validityDayLi"
                            @click="timeChoose('10分钟')"
                        >
                            <div
                                class="validityDayQuan"
                                :class="
                                    subDay == '10分钟' ? 'validityDayQuanA' : ''
                                "
                            >
                                <div
                                    class="validityDayQuandian"
                                    v-if="subDay == '10分钟'"
                                ></div>
                            </div>
                            <span>10</span>分钟
                        </div>
                        <div class="validityDayLi" @click="timeChoose('7天')">
                            <div
                                class="validityDayQuan"
                                :class="
                                    subDay == '7天' ? 'validityDayQuanA' : ''
                                "
                            >
                                <div
                                    class="validityDayQuandian"
                                    v-if="subDay == '7天'"
                                ></div>
                            </div>
                            <span>7</span>天
                        </div>
                        <div class="validityDayLi" @click="timeChoose('14天')">
                            <div
                                class="validityDayQuan"
                                :class="
                                    subDay == '14天' ? 'validityDayQuanA' : ''
                                "
                            >
                                <div
                                    class="validityDayQuandian"
                                    v-if="subDay == '14天'"
                                ></div>
                            </div>
                            <span>14</span>天
                        </div>
                        <div class="validityDayLi" @click="timeChoose('30天')">
                            <div
                                class="validityDayQuan"
                                :class="
                                    subDay == '30天' ? 'validityDayQuanA' : ''
                                "
                            >
                                <div
                                    class="validityDayQuandian"
                                    v-if="subDay == '30天'"
                                ></div>
                            </div>
                            <span>30</span>天
                        </div>

                        <div
                            class="validityDayLi"
                            @click="timeChoose('永久有效')"
                        >
                            <div
                                class="validityDayQuan"
                                :class="
                                    subDay == '永久有效'
                                        ? 'validityDayQuanA'
                                        : ''
                                "
                            >
                                <div
                                    class="validityDayQuandian"
                                    v-if="subDay == '永久有效'"
                                ></div>
                            </div>
                            <div>
                                <span>永久有效</span>
                                <div class="tip">
                                    在手动取消前，分享将持续有效
                                </div>
                            </div>
                        </div>
                        <div
                            class="validityDayLi"
                            @click="timeChoose('自定义')"
                        >
                            <div
                                class="validityDayQuan"
                                :class="
                                    subDay == '自定义' ? 'validityDayQuanA' : ''
                                "
                            >
                                <div
                                    class="validityDayQuandian"
                                    v-if="subDay == '自定义'"
                                ></div>
                            </div>
                            <el-date-picker
                                v-model="dayTime"
                                align="right"
                                type="date"
                                placeholder="选择日期"
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd"
                                :editable="false"
                                v-if="subDay == '自定义'"
                            >
                            </el-date-picker>
                            <div v-if="subDay != '自定义'">
                                <span>自定义</span>到期日
                                <div class="tip">可以设定365天内任意有效期</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="validityBtn" @click="sureTime">确定</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { listMyReceive, createShare, setShareValidityData } from '@/api/index'
import QRCode from 'qrcode'

export default {
    data() {
        return {
            dataList: [],
            selectedData: [],
            dayTime: '',
            pickerOptions: {
                disabledDate(time) {
                    const today = new Date(2025, 6, 10).getTime() // 2025-07-10（月份0-11）
                    const nextYear = today + 365 * 8.64e7 // 当前时间+365天（毫秒数）
                    return time.getTime() < today || time.getTime() > nextYear
                }
            },
            subDay: '10分钟',
            dialogTableVisible: false,
            dialogTime: false,
            dataMsg: {}
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth <= 768
        }
    },
    created() {
        this.init()
    },
    methods: {
        handleCheckChange(item) {
            const index = this.selectedData.findIndex(
                (selected) => selected.id === item.id
            )
            if (index > -1) {
                this.selectedData.splice(index, 1)
            } else {
                this.selectedData.push(item)
            }
        },
        getFileIcon(fileType) {
            const typeMap = {
                图片: 'el-icon-picture',
                视频: 'el-icon-video-camera',
                音频: 'el-icon-headset',
                文档: 'el-icon-document',
                压缩包: 'el-icon-files',
                其他: 'el-icon-question'
            }
            return typeMap[fileType] || typeMap['其他']
        },
        isSelected(item) {
            return this.selectedData.some((selected) => selected.id === item.id)
        },
        // 确认选择的时间
        sureTime() {
            if (this.subDay == '自定义') {
                if (!this.dayTime) {
                    this.$message({
                        message: '请选择到期日期',
                        type: 'error'
                    })
                    return
                }
            }
            console.log(this.dayTime)
            setShareValidityData({
                shareId: this.dataMsg.id,
                validityData:
                    this.subDay == '自定义' ? this.dayTime : this.subDay
            }).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        message: '设置成功',
                        type: 'success'
                    })
                    this.dataMsg = res.data
                    this.dialogTime = false
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    })
                }
            })
        },
        // 发送
        send() {
            console.log(this.selectedData)
            if (this.selectedData.length <= 0) {
                this.$message({
                    message: '请选择文件',
                    type: 'error'
                })
                return
            }
            let array = []
            for (var a = 0; a < this.selectedData.length; a++) {
                array.push(this.selectedData[a].id)
            }
            createShare({ ids: array.join(',') }).then((res) => {
                if (res.code == 0) {
                    this.dataMsg = res.data
                    this.dialogTableVisible = true
                    this.$nextTick(() => {
                        QRCode.toCanvas(
                            this.$refs.qrCanvas,
                            res.data.shareCode,
                            {
                                width: 180,
                                margin: 2,
                                color: {
                                    dark: '#000000', // 确保颜色值有效
                                    light: '#ffffff'
                                }
                            },
                            (error) => {
                                if (error) console.error(error)
                            }
                        )
                    })

                    // setTimeout(()=>{
                    // 	this.creatQrcode()
                    // },2000)
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    })
                }
            })

            // this.dialogTableVisible = true
        },
        // 选择有效期时间
        timeChoose(name) {
            // if ((name = '自定义')) {
            // }
            this.subDay = name
        },
        // 选择发送的文件
        handleSelectionChange(val) {
            this.selectedData = val
        },
        // 某一行点击
        rowClick(event) {
            window.open(event.filePath, '_blank')
        },
        init() {
            listMyReceive().then((res) => {
                if (res.code == 0) {
                    for (var a = 0; a < res.data.length; a++) {
                        res.data[a].checked = false
                    }
                    this.dataList = res.data
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    padding: 25px;
    box-sizing: border-box;
    display: flex;
    height: calc(100vh - 100px);
    flex-direction: column;
}
.tabaleBox {
    flex: 1;
    overflow: auto;
}

.tabBtn {
    display: flex;
    align-items: center;
    .tabBtnLi {
        margin-left: 30px;
        text-align: center;
        .tabBtnLiImg {
            width: 42px;
            height: 42px;
            border-radius: 8px;
            background: rgba(1, 149, 255, 0.1);
            display: flex;
            align-items: center;
            justify-content: center;

            margin: 0 auto;
            img {
                width: 18px;
                height: 18px;
            }
        }

        .tabBtnName {
            color: rgb(1, 149, 255);
            font-size: 12px;
            font-weight: 400;
            font-family: 'HarmonyOSSansSC';
            margin-top: 10px;
        }
    }
}
.erwmBox {
    text-align: center;
    .erwmNum {
        color: #000000;
        font-size: 60px;
        font-weight: 700;
        font-family: 'HarmonyOSSansSC';
    }

    .erwmImg {
        width: 238px;
        height: 238px;
        margin: 0 auto;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .erwmTip {
        color: #9a9a9a;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        font-family: 'HarmonyOSSansSC';
    }
    .erwmTime {
        width: 438px;
        height: 64px;
        border-radius: 16px;
        background: #ffffff;
        box-shadow: 0 2px 10px 0 #0000001a;
        margin: 22px auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        padding: 0 20px;

        box-sizing: border-box;
        .erwmTimeName {
            color: #000000;
            font-size: 16px;
            font-weight: 500;
            font-family: 'HarmonyOSSansSC';
        }

        .erwmTimeKey {
            color: #0195ff;
            font-size: 16px;
            font-weight: 500;
            font-family: 'HarmonyOSSansSC';
        }
    }
    .erwmBtn {
        width: 256px;
        height: 64px;
        border-radius: 60px;
        background: #0195ff;
        box-shadow: 0 2px 30px 0 #0195ff4d;
        margin: 0 auto;
        color: #ffffff;
        font-size: 24px;
        font-weight: 500;
        font-family: 'HarmonyOSSansSC';
        display: flex;

        align-items: center;
        justify-content: center;
    }
}
::v-deep .el-dialog {
    border-radius: 15px !important;
}
.timeCss {
    z-index: 99999999 !important;
}

.validityBox {
    .validity {
        display: flex;
        .validityTit {
            color: #1d1d1d;
            font-size: 14px;
            font-weight: 400;
            font-family: 'HarmonyOSSansSC';
            span {
                color: #f0153f;
            }
        }
        .validityDay {
            margin-left: 20px;
            .validityDayLi {
                display: flex;
                align-items: center;
                color: #000000;
                font-size: 14px;
                font-weight: 500;
                font-family: 'HarmonyOSSansSC';

                margin-bottom: 24px;
                .validityDayQuan {
                    width: 24px;
                    height: 24px;
                    border-radius: 60px;
                    border: 1px solid #d4d6d9;
                    background: #ffffff;
                    margin-right: 10px;

                    display: flex;

                    align-items: center;
                    justify-content: center;
                    .validityDayQuandian {
                        width: 14px;
                        height: 14px;
                        background: #ffffff;
                        border-radius: 50%;
                    }
                }
                .validityDayQuanA {
                    background: #0195ff;
                }
                .tip {
                    color: #9a9a9a;
                    font-size: 14px;
                    font-weight: 400;
                    font-family: 'HarmonyOSSansSC';
                }
                span {
                    color: #0195ff;
                    margin-right: 5px;
                }
            }
        }
    }
    .validityBtn {
        width: 340px;
        height: 52px;
        border-radius: 60px;
        background: #0195ff;
        box-shadow: 0 2px 30px 0 #0195ff4d;
        margin: 0 auto;
        color: #ffffff;
        font-size: 24px;
        font-weight: 500;
        font-family: 'HarmonyOSSansSC';
        display: flex;

        align-items: center;
        justify-content: center;
    }
}

/* 移动端卡片式布局 */
.mobile-file-list {
    padding: 10px;
    overflow-y: auto;
    flex: 1;
}

.file-card {
    background: #fff;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #eee;

    &.selected {
        border-color: #0195ff;
        background-color: rgba(1, 149, 255, 0.05);
    }

    .card-header {
        display: flex;
        align-items: center;

        .el-checkbox {
            margin-right: 12px;
        }

        .file-icon {
            margin-right: 12px;
            font-size: 24px;
            color: #0195ff;
        }

        .file-info {
            flex: 1;
            overflow: hidden;

            .file-name {
                font-size: 14px;
                color: #333;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .file-meta {
                display: flex;
                justify-content: space-between;
                font-size: 12px;
                color: #999;
                margin-top: 4px;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .content {
        padding: 15px !important;
        height: calc(100vh - 80px) !important;
    }

    .tabBtn {
        justify-content: center;
        .tabBtnLi {
            margin-left: 20px !important;
            .tabBtnLiImg {
                width: 36px !important;
                height: 36px !important;
                img {
                    width: 16px !important;
                    height: 16px !important;
                }
            }
            .tabBtnName {
                font-size: 11px !important;
                margin-top: 5px !important;
            }
        }
    }

    /* 表格调整 */
    ::v-deep .el-table {
        th,
        td {
            padding: 8px 0 !important;
        }
        .el-table-column--selection .cell {
            padding-left: 10px !important;
        }
    }

    /* 二维码弹窗 */
    .erwmBox {
        .erwmNum {
            font-size: 36px !important;
        }
        .erwmImg {
            width: 180px !important;
            height: 180px !important;
        }
        .erwmTip {
            font-size: 14px !important;
        }
        .erwmTime {
            width: 100% !important;
            height: 50px !important;
            margin: 15px auto !important;
            padding: 0 15px !important;
        }
        .erwmBtn {
            width: 80% !important;
            height: 50px !important;
            font-size: 18px !important;
        }
    }

    /* 有效期设置弹窗 */
    .validityBox {
        .validity {
            flex-direction: column !important;
            .validityDay {
                margin-left: 0 !important;
                margin-top: 15px !important;
                .validityDayLi {
                    margin-bottom: 15px !important;
                    .el-date-picker {
                        width: 100% !important;
                    }
                }
            }
        }
        .validityBtn {
            width: 100% !important;
            height: 45px !important;
            font-size: 18px !important;
        }
    }

    /* 对话框调整 */
    ::v-deep .el-dialog {
        width: 90% !important;
        &__header {
            padding: 15px 20px !important;
        }
        &__body {
            padding: 20px !important;
        }
    }
    /* 隐藏PC表格 */
    .tabaleBox {
        display: none;
    }

    /* 显示移动端卡片 */
    .mobile-file-list {
        display: block;
    }

    /* 调整其他移动端样式 */
    .content {
        padding: 10px;
    }
}
</style>